<template>
  <div>
    <!-- 面包屑导航 -->
    <!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
    <!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
    <!--      <el-breadcrumb-item>车辆提醒到期提醒</el-breadcrumb-item>-->
    <!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索  新增-->

      <el-form
          :inline="false"
          :model="searchForm"
          :rules="searchRules"
          ref="searchForRef"
          autocomplete="on"
          size="small"
      >

        <el-form-item label="关键字" size="small" label-width="70px">

          <span>
            <el-input v-model="searchForm.name" style="width: 200px" @click.native="chooseCar" placeholder="请输入车牌号/车主" clearable type="text"></el-input>
          </span>
          <span>
            <el-button type="success" @click="searchSubmit()">搜索</el-button>
          </span>
          <span>
              <el-button  @click="toExcel()">导出Excel</el-button>
          </span>

        </el-form-item>

        <el-form-item >

          <div
              v-for="(item, index) in dayList"
              :key="index"
          >
            <el-button
                :type="item.type"
                @click="searchSubmit2(item.id,index)"
                style="height: 100%;float: left;width: 20%; font-weight: bold;line-height: 20px; font-size: 16px;"
            >
              <div class="title">{{item.name}}</div>
              <div class="value">台次：{{item.total}}</div>

            </el-button>
          </div>



        </el-form-item>
      </el-form>


      <div class="centerStyle">
        <el-button size="small">
          已选：{{ sum }}
        </el-button>
        <el-button type="danger" size="small" @click="doAnnuaDue()">
          批量操作审验
        </el-button>

      </div>

      <!-- 表格 -->
      <el-table
          ref="multipleTable"
          :data="tableLoadData"
          height="550px"
          border stripe
          size="mini"
          :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName"
      >
        <el-table-column
            type="selection"
            align="center"

            width="50px">
        </el-table-column>
        <!--        <el-table-column-->
        <!--            label="ID"-->
        <!--            min-width="5%"-->
        <!--            prop="id"-->
        <!--            :show-overflow-tooltip='true'>-->
        <!--        </el-table-column>-->
        <el-table-column
            label="所有人"
            prop="allPerson"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="车主"
            prop="username"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="车牌"
            prop="plate_number"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="手机号"
            prop="mobile"
            :show-overflow-tooltip='true'></el-table-column>
        <el-table-column
            label="注册日期"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            {{ scope.row.register_date  }}
          </template>
        </el-table-column>
        <el-table-column
            label="到期天数"
            prop="day"
        ></el-table-column>
        <el-table-column
            label="年审到期日期"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            {{ scope.row.year_check_time | dateFormat2 }}
          </template>
        </el-table-column>

        <el-table-column
            label="操作">
          <template slot-scope="scope">
            <span v-if="scope.row.next_year_time">
               {{ scope.row.next_year_time | dateFormat2 }}
            </span>
            <span v-else>
              <el-button type="danger" size="small" @click="doAnnuaDue(scope.row)">
              审验
              </el-button>
            </span>

          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--            label="下次提醒日期"-->
<!--            :show-overflow-tooltip='true'>-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row.next_year_time">-->
<!--               {{ scope.row.next_year_time | dateFormat2 }}-->
<!--            </span>-->
<!--            <span v-else>-->

<!--            </span>-->

<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-card>

  </div>
</template>

<script>
import eTable from "../common/eTable.vue";
import moment from 'moment';    //日期时间转换
import eCar from "../common/eCar";
import table2excel from 'js-table2excel'
export default {
  name: "annuaDue",
  components: {
    eTable,
    eCar
  },
  props: {},
  data() {
    return {
      isShowCar:false,
      tableData:[{id:1}],
      // 搜索
      searchForm: {
        name: '',
        day:'',
      },
      searchRules: {
        name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
      },
      // 数据
      tableLoadData: [

      ],
      limit: 20,
      page:1,// 当前页码
      total:0,//总条目数
      id: '',
      rules: {

      },
      dialogFormVisible: false,
      title: '',
      form: {
      },
      uploadImg: '',
      uploadDialog: false,
      sum: "0",
      multipleSelection: [],
      orderIDs: [],
      selectedDayIndex : 0,
      dayList:[
        // {id:0,name:'全部',type:'',total:0},
        // {id:1,name:'逾期',type:'danger',total:0},
        // {id:3,name:'30天内',type:'warning',total:0},
        // {id:7,name:'30-60天内',type:'primary',total:0},
        // {id:15,name:'60-90天内',type:'success',total:0},
      ],
    };
  },
  created() {
    this.getTotalBtn()
    this.DataList()
  },
  mounted() {

  },
  filters: {
    /**
     * @param {
     *
     * }
     */
    statusFilter(status) {
      if (status == 1) {
        return "启用";
      } else if (status == 2) {
        return "禁用";
      }
    },
    //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },
    dateFormat2(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD");
    },

  },
  methods: {
    chooseCar(){
      this.isShowCar=true;
      //console.log('dddd',this.isShowCar)
    },
    //接收子组件传过来的值
    chooseCarInfo(car_number,...params){
      this.searchForm.name=car_number;

    },
    getTotalBtn(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      if(this.searchForm.name){
        param.queryParams=this.searchForm.name.trim();
      }
      this.$axios.getTradRemindBtn(param).then(res=>{
        if(res.code == 200){
          this.dayList = res.data
        }
      }).catch(error=>{
        //console.log(error);
      })
    },DataList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        page: this.page,
        pageSize: this.limit,
      }
      if(this.searchForm.name){
        param.queryParams=this.searchForm.name.trim();
      }
      if(this.searchForm.day){
        param.day=this.searchForm.day;
      }
      this.$axios.getSysTradRemindList(param).then(res=>{
        if(res.code == 200){
          this.tableLoadData = res.data.data
          this.total = res.data.total
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.limit = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.page = newPage
      this.DataList()
    },
    // 新增
    addData() {
      this.title = '新增'
      this.form = {
        // role_name: '',
      }
      this.dialogFormVisible = true
    },
    handelEdit(index,row) {
      this.id = index.id

      this.title = '编辑'
      this.form = {
      }
      this.dialogFormVisible = true
      // this.form = {...row};
      // 或者
      this.form = JSON.parse(JSON.stringify(index))
    },

    reset_dialogForm(formName) {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    searchSubmit() {
      this.page = 1
      this.DataList()
      this.getTotalBtn()
    },
    searchSubmit2(day,index) {
      this.selectedDayIndex = index;
      this.searchForm.day = day;
      this.page = 1
      this.DataList()
      this.getTotalBtn()
    },
    doAnnuaDue(row={}){

      this.$confirm('已审验, 请点击确认?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log('row-saveCarAnnual',row,this.orderIDs);
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          car_id: [],
        }
        if(row.id){
          param.car_id.push(row.id);
        }else{
          param.car_id = this.orderIDs;
        }

        this.$axios.saveTradeAnnual(param).then(res=>{
          if(res.code == 200){
            this.DataList();
            this.getTotalBtn()
            this.$message.success(res.msg)
          }else {
            this.$message.error(res.msg)
          }
        }).catch(error=>{
          //console.log(error);
          this.$message.error(error);
        })


      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审验'
        });
      });
    },
    //统计函数
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.sum = val.length + '个';
      let ids2 = []
      val.forEach(v => {
        ids2.push(v.id)
      });
      this.orderIDs = ids2
    },
    //行的样式
    tableRowClassName({row, rowIndex}) {
      // console.log('row',row,rowIndex)
      // let date = row.year_check_time;
      let day = row.day;
      // let now = new Date().getTime()
      // now = parseInt(now/1000)
      // let gap = date - now;
      // if(gap < 0){
      //   return 'regFont'
      // }
      // let day = Math.ceil(gap/(60*60*24))
      // console.log('day',day)
      if(day <=0){
        return 'regFont';
      }
      else if(day <= 30 && day>0){
        return 'orangeFont';
      }
      else if(day <= 60 && day>30){
        return 'blueFont';
      }
      else if(day <= 90 && day >60){
        return 'greenFont';
      }
      else{
        return '';
      }
    },
    //支持导出图片和类型转换
    toExcel() {
      const column = [
        {
          title: '所有人',
          key: 'allPerson',
          type: 'text'
        },
        {
          title: '车主',
          key: 'username',
          type: 'text'
        },
        {
          title: '车牌',
          key: 'plate_number',
          type: 'text'
        },

        {
          title: '手机号',
          key: 'mobile',
          type: 'text'
        },
        {
          title: '注册日期',
          key: 'register_date',
          type: 'text'
        },
        {
          title: '到期天数',
          key: 'day',
          type: 'text'
        },
        {
          title: '年审到期日期',
          key: 'year_check_time',
          type: 'text'
        }
      ]
      //this.tableLoadData
      //let tableDatas = JSON.parse(JSON.stringify( res.data.data))
      for(var i in this.tableLoadData){
        this.tableLoadData[i]['year_check_time'] = this.getTime(this.tableLoadData[i]['year_check_time'] * 1000);
        this.tableLoadData[i]['username'] = this.tableLoadData[i]['username']?this.tableLoadData[i]['username']:'';
        this.tableLoadData[i]['mobile'] = this.tableLoadData[i]['mobile']?this.tableLoadData[i]['mobile']:'';

      }
      table2excel(column, this.tableLoadData, '营业证到期报表')
    },
    getTime (time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      return y + '-' + m + '-' + d
    },
  },
};
</script>
<style>
.table_name{
  font-weight: bold;
  /* border: 1px solid #f00; */
}
.table_name:hover{
  color: #409EFF;
  cursor: pointer;
}
.centerStyle{
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: left;
}
.active-button {
  color: #409EFF;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.el-table .regFont {

  color: #F56C6C;
}

.el-table .orangeFont {
  color: #E6A23C;
}
.el-table .blueFont {
  color: #409EFF;
}
.el-table .greenFont {
  color: #67C23A;
}
</style>



// WEBPACK FOOTER //
// src/view/remind/tradingList.vue